import {
    configureStore
} from '@reduxjs/toolkit'

import inputFields from './roiStore.ts'

export const store = configureStore({
    reducer: {
        inputFields,
    },
})